import { render, staticRenderFns } from "./sales-invoices-dashboard.vue?vue&type=template&id=9feba3ee&scoped=true&"
import script from "./sales-invoices-dashboard.component.ts?vue&type=script&lang=ts&"
export * from "./sales-invoices-dashboard.component.ts?vue&type=script&lang=ts&"
import style0 from "./sales-invoices-dashboard.vue?vue&type=style&index=0&id=9feba3ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9feba3ee",
  null
  
)

export default component.exports